import cx from 'classnames';
import type { CustomButtonProps } from '../Button/index.js';
import Button, { isButtonProps } from '../Button/index.js';
import CircularLoader from '../CircularLoader/index.js';

export type LoadingButtonProps = {
  loading: boolean;
} & CustomButtonProps;

export default function LoadingButton({
  loading,
  className,
  children,
  ...props
}: LoadingButtonProps) {
  return (
    <Button
      {...props}
      {...(isButtonProps(props)
        ? {
            disabled: props.disabled || loading,
          }
        : {})}
      className={cx('loading-button', className, {
        'loading-button--active': loading,
      })}
    >
      {loading ? <CircularLoader className="loading-button__loader" /> : null}
      <span>{children}</span>
    </Button>
  );
}
